<template>
  <div id="app" class="flex-layout">
    <app-header v-if="!$route.meta.isApp" ref="header"/>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ref="view" class="flex-layout-cont"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ref="view" class="flex-layout-cont"/>
    <app-footer v-if="!$route.meta.isApp"/>
    <app-box v-if="!$route.meta.isApp"/>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // sessionStorage.getItem("state") &&
    //   this.$store.replaceState(JSON.parse(sessionStorage.getItem("state")));
    if (
      !(
        !this.$cookies.get("supplier_id") ||
        !this.$cookies.get("uid") ||
        !this.$cookies.get("browser_token")
      )
    ) {
      this.$store.dispatch("userOrMerchant/merchantStatusAction", true);
      this.$store.dispatch("userOrder/changeCartNumAction");
    } else if (
      !(!this.$cookies.get("uid") || !this.$cookies.get("browser_token"))
    ) {
      this.$store.dispatch("userOrMerchant/userStatusAction", true);
      this.$store.dispatch("userOrder/changeCartNumAction");
    } else {
      this.$store.dispatch("userOrMerchant/merchantStatusAction", false);
      this.$store.dispatch("userOrMerchant/userStatusAction", false);
    }
  },
  components: {
    appHeader: resolve => require(["./components/header.vue"], resolve),
    appFooter: resolve => require(["./components/footer.vue"], resolve),
    appBox: resolve => require(["./components/kefuChe.vue"], resolve)
  },
  mounted() {
    // window.addEventListener("unload", this.saveState);
    var isM = this.isMobile();
    if (isM) {
      window.location.href = "https://m.dazuhang.com";
    }
  },
  methods: {
    saveState() {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    },
    isMobile() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      var flag = false;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = true;
          break;
        }
      }
      return flag;
    }
  }
};
</script>
  
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  font-size: 12px !important;
}
html,
body {
  min-width: 1500px;
}
.header-fixed {
  min-width: 1500px;
}
.flex-layout a {
  text-decoration: none !important;
  color: #555;
  cursor: pointer;
}
.flex-layout a:hover {
  color: #ff6b56;
}
.flex-layout p {
  margin-bottom: 0;
}
.flex-layout ul {
  padding: 0;
}
.router-link {
  color: #555;
}
img[lazy="loading"] {
  background: url(/static/img/static_pic.jpg) no-repeat;
  background-size: cover;
}
img[lazy="error"] {
  background: url(/static/img/static_pic.jpg) no-repeat;
  background-size: cover;
}
img[lazy="loaded"] {
}

.banner[lazy="loading"],
.banner[lazy="error"],
.banner[lazy="loaded"] {
  background: #fec2c6;
}

.container {
  width: 1140px !important;
  max-width: 1140px !important;
}

/* flex布局，促使footer一直在页面最底部 */
.flex-layout {
  /* display: flex;
  display: -webkit-flex; */
  display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
  display: -moz-box; /* 老版本语法: Firefox (buggy) */
  display: -ms-flexbox; /* 混合版本语法: IE 10 */
  display: -webkit-flex; /* 新版本语法: Chrome 21+ */
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */

  min-height: 100vh;
  flex-direction: column;
}
.flex-layout-cont {
  /* flex: 1; */
  -webkit-box-flex: 1;
  -moz-flex-grow: 1;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  min-height: calc(100vh - 280px);
  min-height: -webkit-calc(100vh - 280px);
  position: relative;
}

/* 滚动条设置 */
::-webkit-scrollbar {
  width: 0;
  height: 10px;
}
::-webkit-scrollbar-corner,
::-webkit-scrollbar-track {
  background-color: #e2e2e2;
}
::-webkit-scrollbar-thumb {
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-corner,
::-webkit-scrollbar-track {
  background-color: #e2e2e2;
}

.html img {
  max-width: 100% !important;
  height: auto;
}

/* 通用样式 */
ul {
  list-style: none;
}
/* 超出一行省略 */
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/* 超出两行省略 */
.line2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 100%;
}
.word-break{
  word-break: break-all;
}
.clearfix:after {
  display: table;
  content: "";
  clear: both;
}
/* flex-direction:row */
.flex-row {
  display: -webkit-flex;
  display: flex;
}
/* flex-direction:column */
.flex-column {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.space-between{
  justify-content: space-between;
}
.space-around{
  justify-content: space-around;
}
.align-center {
  align-items: center;
}
.flex-end{
  justify-content: flex-end;
}
.flex-1 {
  flex: 1;
}
/* 仿a标签小手，可解决移动端有些span等标签点击事件不好使 */
.pointer {
  cursor: pointer;
}
.btn.focus,
.btn:focus {
  box-shadow: none !important;
}
/* 列表暂无数据 */
.no-data {
  text-align: center;
  width: 100%;
  height: 100px;
  line-height: 100px;
  color: #909399;
  font-size: 18px;
  font-style: italic;
}
/* color:#999 */
.c9 {
  color: #999;
}
.f12 {
  font-size: 12px;
}
.mt5 {
  margin-top: 5px;
}
.line-through {
  text-decoration: line-through;
}
b {
  font-weight: normal !important;
}
/* line-height: 24px */
.lineh24 {
  line-height: 24px;
}
/* padding:0 10px */
.padding010 {
  padding: 0 10px;
}
.a {
  text-decoration: underline;
}
.red {
  color: red;
}

/* el-dialog */
.el-dialog__body {
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}

/* el-input、el-button */
button,
.el-button,
input,
.el-input {
  cursor: pointer;
  outline: none !important;
}
.el-icon-close {
  outline: none !important;
}
#app .el-loading-spinner {
  top: 50%;
}

/* 限制message组件显示的位置 */
.el-message{
  top:60px !important;
}
.el-dialog__body{
  padding:20px !important;
}
.el-date-editor .el-range-separator{
  padding:0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue